interface AnalyticsConfig {
  googleAnalyticsId?: string;
  googleTagManagerId?: string;
  metaPixelId?: string;
}

export async function loadTrackingScripts(config: AnalyticsConfig) {
  try {
    // Load Google Tag Manager (needs to be in head)
    // Strip any extra quotes from the IDs
    const gtmId = config.googleTagManagerId?.replace(/['"]/g, '');
    const gaId = config.googleAnalyticsId?.replace(/['"]/g, '');
    const metaPixelId = config.metaPixelId?.replace(/['"]/g, '');

    if (gtmId) {
      const gtmScript = document.createElement('script');
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
      `;
      document.head.appendChild(gtmScript);

      const gtmNoScript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      gtmNoScript.appendChild(iframe);
      document.body.insertBefore(gtmNoScript, document.body.firstChild);
    }

    // Load Google Analytics
    if (gaId) {
      const gaScript = document.createElement('script');
      gaScript.async = true;
      gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(gaScript);

      const gaConfigScript = document.createElement('script');
      gaConfigScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${gaId}');
      `;
      document.head.appendChild(gaConfigScript);
    }

    if(metaPixelId){
      const pixelScript = document.createElement('script');
      pixelScript.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${metaPixelId}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(pixelScript);

      const gtmNoScript = document.createElement('noscript');
      const img = document.createElement('img');
      img.src = `https://www.facebook.com/tr?id=${metaPixelId}&ev=PageView&noscript=1`;
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.style.visibility = 'hidden';
      gtmNoScript.appendChild(img);
      document.body.insertBefore(gtmNoScript, document.body.firstChild);
    }
  } catch (error) {
    console.error('Failed to load analytics config:', error);
  }
}
